import axios, { getEnv } from './api';

const AdministradoresService = {
  getUser: async (cpf) => {
    try {
      const res = await axios.get(
        `${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/cpf/${cpf}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  postListaUsuario: async (method) => {
    try {
      const res = await axios.post(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/perfil/precadastro`,
        method
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  updateListaUsuario: async (method) => {
    try {
      const res = await axios.put(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/perfil/precadastro`,
        method
      );
      return res;
    } catch (error) {
      return error;
    }
  },
  deleteListaUsuario: async (cpf, idPerfil) => {
    try {
      const res = await axios.delete(
        `${await getEnv(
          'REACT_APP_URL_SERVICE'
        )}/v1/administradores/${cpf}/perfil/${idPerfil}`
      );
      return res;
    } catch (error) {
      return error;
    }
  },
};

export default AdministradoresService;
